module.exports = __webpack_public_path__ + "static/img/idtype_plan.3fcbc212.png";